function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "wallet");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Dashboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "I.-Settings-/-profile",
  transform: "translate(-1232.000000, -131.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "wallet",
  transform: "translate(1232.000000, 131.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.4727891,5.83259064 L12.7501328,5.83259064 L12.7501328,1.19407602 C12.7501328,0.777592593 12.5381973,0.398224172 12.1832227,0.179245614 C11.8283145,-0.0396998051 11.3935527,-0.059251462 11.0202832,0.127019493 C11.015502,0.129405458 11.0107871,0.1318577 11.0060723,0.134376218 L1.15204883,5.42730799 C0.441535156,5.80896296 0.0001328125,6.54635867 0.0001328125,7.35165497 L0.0001328125,7.35695712 L0.0001328125,7.68834113 L0.0001328125,15.4427271 C0.0001328125,16.2832495 0.6853125,16.9670936 1.52747656,16.9670936 L15.4727891,16.9670936 C16.3149531,16.9670936 17.0001328,16.2832495 17.0001328,15.4427271 L17.0001328,7.35695712 C17.0001328,6.5164347 16.3149531,5.83259064 15.4727891,5.83259064 L15.4727891,5.83259064 Z M11.5000684,1.07328655 C11.5527617,1.04909552 11.5967227,1.06414035 11.6246133,1.08133918 C11.6533672,1.09906823 11.6875996,1.13303509 11.6875996,1.19410916 L11.6875996,5.83262378 L2.63951563,5.83262378 L11.5000684,1.07328655 Z M15.9376328,15.4427271 C15.9376328,15.6985556 15.7291172,15.9066647 15.4727891,15.9066647 L1.52747656,15.9066647 C1.27114844,15.9066647 1.06263281,15.6985556 1.06263281,15.4427271 L1.06263281,7.68834113 L1.06263281,7.35695712 C1.06263281,7.10112865 1.27114844,6.89301949 1.52747656,6.89301949 L15.4727891,6.89301949 C15.7291172,6.89301949 15.9376328,7.10112865 15.9376328,7.35695712 L15.9376328,15.4427271 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.8126328,12.460271 C13.2267637,12.460271 12.7501328,11.9845692 12.7501328,11.3998421 C12.7501328,10.815115 13.2267637,10.3394133 13.8126328,10.3394133 C14.398502,10.3394133 14.8751328,10.815115 14.8751328,11.3998421 C14.8751328,11.9845692 14.3984688,12.460271 13.8126328,12.460271 Z",
  id: "Shape"
}))));

var SvgWalletSettings = function SvgWalletSettings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWalletSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/walletSettings.027e9761.svg";
export { ForwardRef as ReactComponent };